import { hasNoElements } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";
import { asType, get, patch } from "./Request";

export async function retrieveIgnoredValues(token: string, projectId: string): Promise<Record<string, unknown>> {
  if (isNullOrWhiteSpace(projectId)) {
    return null;
  }

  const response = await get(`staging/${projectId}/rejected`, token);
  return asType<Record<string, unknown>>(response);
}

export async function removeIgnoredValues(token: string, projectId: string, fieldList: string[]): Promise<void> {
  if (isNullOrWhiteSpace(projectId) || hasNoElements(fieldList)) {
    return;
  }
  await patch(
    `staging/${projectId}/rejected`,
    token,
    JSON.stringify({
      remove: fieldList
    })
  );
}

export async function retrieveStagingValues(token: string, projectId: string): Promise<Record<string, unknown>> {
  if (isNullOrWhiteSpace(projectId)) {
    return null;
  }

  const response = await get(`staging/${projectId}`, token);
  return asType<Record<string, unknown>>(response);
}

export async function saveMergedStagingValues(
  token: string,
  projectId: string,
  mergedProject: Record<string, unknown>
): Promise<void> {
  if (isNullOrWhiteSpace(projectId)) {
    return;
  }

  await patch(`staging/${projectId}/merge`, token, JSON.stringify(mergedProject));
}
